import { atom } from 'recoil';

const BOT_FILTER_KEY = 'sf_bot_filter';

// localStorage effect for boolean value
const localStorageEffect = (key) => ({ setSelf, onSet }) => {
  const savedValue = localStorage.getItem(key);
  if (savedValue != null) {
    setSelf(savedValue === 'true');
  }
  onSet((newValue, _, isReset) => {
    if (isReset) {
      localStorage.removeItem(key);
    } else {
      localStorage.setItem(key, String(newValue));
    }
  });
};

// Bot filter state - filters out suspected bot traffic from analytics.
// Defaults ON to match GA4 (auto-excludes known bots/spiders) and Matomo (excludes
// bots by default). Query-time only: affects pageview/visit counts in Web Stats,
// Dashboard and Reports — it never touches ad impressions/clicks.
export const botFilterAtom = atom({
  key: 'botFilter',
  default: true,
  effects: [localStorageEffect(BOT_FILTER_KEY)],
});
